import { render, staticRenderFns } from "./PassengerUpsell.vue?vue&type=template&id=91816f76&scoped=true"
import script from "./PassengerUpsell.vue?vue&type=script&lang=js"
export * from "./PassengerUpsell.vue?vue&type=script&lang=js"
import style0 from "./PassengerUpsell.vue?vue&type=style&index=0&id=91816f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91816f76",
  null
  
)

export default component.exports